import { render, staticRenderFns } from "./QPlacedDrilldown.vue?vue&type=template&id=10a61415&"
import script from "./QPlacedDrilldown.vue?vue&type=script&lang=js&"
export * from "./QPlacedDrilldown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports